<template>
  <div @click.self="closeCam" class="modal fade" id="WebCamCapture">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <a @click="closeCam" href="#" class="modal-close" id="dismissModal" data-dismiss="modal" aria-label="Close">
          <em class="ti ti-close"></em>
        </a>
        <div class="ath-container m-0">
          <div class="ath-body bg-theme tc-light">
            <h5 class="ath-heading title">WebCam <small class="tc-default" v-if="!displayResult">Capture<br>(Place QR Code in front of Camera)</small></h5>
            <p class="text-center">{{ error }}</p>
            <p class="text-center" style="word-break: break-all;">{{ result }}</p>
            <div class="">
              <div v-if="toggleCam">
                <qrcode-stream @decode="onDecode" @init="onInit" />
              </div>
              <div class="clearfix justify-content-center btnns mt-3">
                <div class="sdiv">
                  <ul class="row" v-if="!displayResult">
                    <li class="col-12 text-center"><button @click="cancelCam" type="button" class="btn-1" id="close-camera-popup"><i class="ti ti-close"></i>&nbsp;&nbsp; Cancel </button></li>
                    <li>
                      <button type="button" class="btn-2" style="display: none;"><i class="fa fa-camera"></i>&nbsp;&nbsp; Capture</button>
                      <button type="button" class="btn-3" style="display: none;"><i class="fa fa-redo"></i>&nbsp;&nbsp; Retake</button>
                    </li>
                    <li> <button @click="toggleCam = false" type="button" class="btn-4" id="done-with-camera-popup" style="display: none;"><i class="fa fa-check"></i>&nbsp;&nbsp; Done</button></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="ath-note text-center" style="display:none;">
              Don’t have an account?
              <a href="#"><strong>Sign up here</strong></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-undef */
import { QrcodeStream } from 'vue-qrcode-reader'
import { bus } from '../main'

const serialNumberRegex = /^\d{6}-\d{4}-\d{12}-\d{1}-\d{6}$/

export default {
  components: { QrcodeStream },
  data () {
    return {
      result: '', 
      error: '',
      toggleCam: false,
      displayResult: ''
    }
  },
  created () {
    bus.$on('toggleCam', (data) => {
      this.toggleCam = data
      this.displayResult = false
      this.error = ''
    })
  },
  methods: {
    onDecode (result) {
      this.result = result
      if (serialNumberRegex.test(this.result)) {
        bus.$emit('camResult', this.result)
        this.toggleCam = false
        $('#dismissModal').click();
        this.result = ''
      } else {
        this.toggleCam = false
        this.displayResult = true
      }
    },
    // captureCam () {
    //   this.result = ''
    //   this.toggleCam = true
    // },
    closeCam () {
      this.toggleCam = false
      this.result = ''
    },
    cancelCam () {
      this.toggleCam = false
      $('#dismissModal').click()
      this.result = ''
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        this.displayResult = true
        this.toggleCam = false
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    }
  }
}
</script>

<style scoped>
  button {
    outline: none;
  }
</style>
